<div *transloco="let t" class="timeline">
	@if (model().events.length === 0) {
		<div class="text-black/50 italic p-4">{{ t('common.noData') }}</div>
	} @else {
		<div class="flex flex-row items-start w-full">
			<div class="flex-none w-36 pr-2">
				@for (lane of laneList(); track $index) {
					<div class="flex items-center text-xs font-semibold text-black/60" [class.lane-label--main]="lane.main" [style.height.px]="rowHeight">
						{{ lane.label }}
					</div>
				}
			</div>

			<div class="flex-1 min-w-0 overflow-x-auto">
				<div class="relative" [style.width.px]="view().width" [style.height.px]="view().height">
					<svg class="absolute inset-0 pointer-events-none" [attr.width]="view().width" [attr.height]="view().height">
						@for (line of view().connectors; track $index) {
							<line
								class="stroke-gray stroke-2 opacity-60"
								[attr.x1]="line.x1"
								[attr.y1]="line.y1"
								[attr.x2]="line.x2"
								[attr.y2]="line.y2"></line>
						}
						@for (dot of view().dots; track $index) {
							<circle class="fill-gray opacity-70" [attr.cx]="dot.x" [attr.cy]="dot.y" r="3"></circle>
						}
					</svg>

					@for (card of view().cards; track card.key) {
						<div
							class="absolute"
							[style.left.px]="card.left"
							[style.top.px]="card.top"
							[style.width.px]="card.width"
							[style.height.px]="cardHeight">
							<ara-popover class="ts-popover block w-full h-full" [content]="card.tooltip">
								<button
									type="button"
									(click)="emitOpen(card)"
									class="flex flex-col justify-center gap-1 w-full h-full px-3 py-1.5 text-left cursor-pointer transition-colors border rounded-[10px] shadow-sm hover:border-primary"
									[class.bg-green-light]="card.isOpen"
									[class.border-green]="card.isOpen"
									[class.bg-gray-light]="!card.isOpen"
									[class.border-gray]="!card.isOpen">
									<span class="truncate text-[0.8rem] font-semibold text-black/85">{{ card.title }}</span>
									<span class="flex">
										<ara-generic-chip [label]="display.periodLabel(card.role)"></ara-generic-chip>
									</span>
								</button>
							</ara-popover>
						</div>
					}
				</div>
			</div>
		</div>
	}
</div>
